import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDeleteCommentUrl,
  getCommentUrl,
  getPostCommentUrl
} from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";

const initialState = {};

const commentSlice = createSlice({
  name: "comment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postCommentsThunk.rejected, (state, action) => {
        showToast(action.payload?.data?.message, showToastType.error);
        if (action.payload && !action.payload.status === 404) {
          showToast(action?.payload?.data?.message, showToastType.error);
        }
      })
      .addCase(deleteCommentsThunk.rejected, (state, action) => {
        showToast(action.payload?.data?.message, showToastType.error);
        if (action.payload && action.payload.status === 500) {
          const apiFieldErrors = action.payload.data.errors[0];
          showToast(apiFieldErrors, showToastType.error);
        }
      });
  }
});

// Async thunk to get Comments data
export const getCommentsThunk = createAsyncThunk(
  "comment/getCommentsThunk",
  async (payload) => {
    try {
      const response = await privateAxios.get(getCommentUrl(payload.id), {
        params: payload.params
      });
      return response;
    } catch {
      // handle catch here;
    }
  }
);

// Async thunk to Post Comments data
export const postCommentsThunk = createAsyncThunk(
  "comment/postCommentsThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getPostCommentUrl, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Async thunk to Delete Comments data
export const deleteCommentsThunk = createAsyncThunk(
  "comment/deleteCommentsThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(getDeleteCommentUrl(payload));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export default commentSlice.reducer;
